<template>
  <div class="dashboard">
    <!-- <div class="app-panel blank-v blank-h panel-1">
      <p>{{timeText()}}，<template v-if="$store.state.userInfo">{{$store.state.userInfo.account_attr_data.account_attr_phone}}</template>，开始您一天的工作吧~</p>
      <p>{{calendar.year}}年{{calendar.month}}月{{calendar.day}}日</p>
    </div> -->
    <div class="app-panel panel-2 blank-v blank-h" @click="initDialog('今日到访客户', initOneDatas)">
      <p class="app-title mb">今日到访客户</p>
      <p>{{numberOne}}</p>
    </div>
    <div class="app-panel panel-3 blank-v blank-h" @click="initDialog('今日首访客户', initTwoDatas)">
      <p class="app-title mb">今日首访客户</p>
      <p>{{numberTwo}}</p>
    </div>
    <div class="app-panel panel-4 blank-v blank-h" @click="initDialog('今日认证客户', initThreeDatas)">
      <p class="app-title mb">今日认证客户</p>
      <p>{{numberThree}}</p>
    </div>
    <div class="app-panel blank-v blank-h panel-5">
      <p class="app-title mb">今日客流趋势</p>
      <ve-line :data="chart.datas" :colors="chart.colors"></ve-line>
    </div>
    <el-drawer custom-class="info" :title="dialog.title" :visible.sync="dialog.show" center size="85%" append-to-body>
      <div v-loading="dialog.loading" v-if="dialog.show">
        <template v-if="dialog.page.total">
          <div class="el-table">
            <div class="item" v-for="(value, index) in dialog.datas" :key="index" @click="showDialog(value)">
              <el-image :src="value.url"></el-image>
              <p class="number">{{value.name}}</p>
              <el-tag size="small">{{value.tag}}</el-tag>
              <p class="text">{{value.text_1}}<br>{{value.text_2}}</p>
            </div>
          </div>
          <el-pagination :total="dialog.page.total" :page-size="dialog.page.pageSize" :current-page="dialog.page.currentPage" @current-change="currentChange" background></el-pagination>
        </template>
        <div class="empty" v-else><i class="el-icon-warning"></i>暂无数据</div>
      </div>
    </el-drawer>
    <el-drawer custom-class="info" :title="infoDialog.title" :visible.sync="infoDialog.show" center size="80%" append-to-body>
      <customer-info :id="infoDialog.id" v-if="infoDialog.show"></customer-info>
    </el-drawer>
    <el-drawer :title="certificationDialog.title" :visible.sync="certificationDialog.show" center append-to-body>
      <certification-info :id="certificationDialog.id" v-if="certificationDialog.show"></certification-info>
    </el-drawer>
  </div>
</template>

<script>
  import Calendar from '@/assets/utils/calendar.js';
  import CommonService from '@/io/common.js';
  import DashboardService from '@/io/dashboard.js';
  import CustomerService from '@/io/customer.js';
  import CertificationService from '@/io/certification.js';
  import CustomerInfo from '@/views/CustomerInfo.vue';
  import CertificationInfo from '@/views/CertificationInfo.vue';

  export default {
    name: 'Dashboard',
    data() {
      return {
        infoDialog: {
          title: '客户详情',
          show: false,
          id: null
        },
        certificationDialog: {
          title: '认证详情',
          show: false,
          id: null
        },
        dialog: {
          title: '',
          show: false,
          loading: false,
          datas: [],
          page: {
            pageSize: 0,
            total: 0,
            currentPage: 1
          },
          func: null
        },
        calendar: new Calendar({}),
        name: '',
        numberOne: 0,
        numberTwo: 0,
        numberThree: 0,
        chart: {
          datas: {
            columns: [],
            rows: []
          },
          colors: ['#3BA0FF'],
        }
      }
    },
    components: {
      CustomerInfo,
      CertificationInfo
    },
    mounted() {
      DashboardService.data().then(res => {
        this.numberOne = res[0].data.today_volume;
        this.numberTwo = res[0].data.today_first_volume;
        this.numberThree = res[0].data.contract_count;
        this.chart.datas = {
          columns: ['指标', '访问人数'],
          rows: res[1].data.result_arr.map((value, index) => {
            return {
              '指标': res[1].data.times_arr[index],
              '访问人数': value
            }
          })
        };
      }).catch(() => {});
    },
    methods: {
      showDialog(data) {
        if (data.customer_id) {
          this.infoDialog.show = true;
          this.infoDialog.id = data.customer_id;
        } else {
          this.certificationDialog.show = true;
          this.certificationDialog.id = data.contract_id;
        }
      },
      initDialog(title, func) {
        this.dialog.title = title;
        this.dialog.show = true;
        this.dialog.func = func;
        this.dialog.datas = [];
        this.dialog.page = {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
        this.initDatas();
      },
      initDatas() {
        this.dialog.loading = true;
        CommonService.serverTime().then(res => {
          return this.dialog.func(res.data.date);
        }).catch(() => {}).finally(() => {
          this.dialog.loading = false;
        });
      },
      initOneDatas(date) {
        return CustomerService.visitListPage(
          date,
          date,
          this.dialog.page.currentPage
        ).then(res => {
          this.dialog.datas = res.data.data.map(val => {
            return {
              customer_id: val.customer_id,
              url: val.recognition_log_data.provide_attachment_data.attachment_access_url,
              name: val.project_customer_open_id,
              tag: `${val.project_customer_attr_age}岁`,
              text_1: '到访时间',
              text_2: val.recognition_log_data.project_customer_recognition_log_recognition_at
            }
          });
          this.dialog.page.pageSize = res.data.per_page;
          this.dialog.page.total = res.data.total;
        }).catch(() => {});
      },
      initTwoDatas(date) {
        return CustomerService.listPage(
          null,
          null,
          null,
          date,
          date,
          this.dialog.page.currentPage
        ).then(res => {
          let datas = [];
          res.data.data.forEach(val => {
            if (val.face_data.length) { 
              datas.push(val);
            }
          });
          this.dialog.datas = datas.map(val => {
            return {
              customer_id: val.customer_id,
              url: val.face_data[0].attachment_data.attachment_access_url,
              name: val.project_customer_open_id,
              tag: `${val.attr_data.project_customer_attr_age}岁`,
              text_1: '首次抓拍时间',
              text_2: val.first_recognition_at
            }
          });
          this.dialog.page.pageSize = res.data.per_page;
          this.dialog.page.total = res.data.total;
        }).catch(() => {});
      },
      initThreeDatas(date) {
        return CertificationService.listPage(
          null,
          null,
          date,
          date,
          this.dialog.page.currentPage
        ).then(res => {
          this.dialog.datas = res.data.data.map(val => {
            return {
              contract_id: val.contract_id,
              url: val.contract_attachment_data.attachment_access_url,
              name: val.contract_customer_identity_name,
              tag: val.contract_type === 1 ? '一体机' : '小程序',
              text_1: '认证时间',
              text_2: val.contract_date
            };
            return val;
          });
          this.dialog.page.pageSize = res.data.per_page;
          this.dialog.page.total = res.data.total;
        }).catch(() => {});
      },
      currentChange(page) {
        this.dialog.page.currentPage = page;
        this.initDatas();
      },
      timeText() {
        let hour = this.calendar.hour;
        let text = '';
        if (hour < 6) {
          text = '凌晨好';
        } else if (hour < 9) {
          text = '早上好';
        } else if (hour < 12) {
          text = '上午好';
        } else if (hour < 14) {
          text = '中午好';
        } else if (hour < 17) {
          text = '下午好';
        } else if (hour < 19) {
          text = '傍晚好';
        } else if (hour < 22) {
          text = '晚上好';
        } else {
          text = '夜里好';
        }
        return text;
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .dashboard {
    margin: -10px;
    .app-panel {
      box-shadow: 0px 0px 20px 0px rgba(102, 126, 164, 0.05);
      float: left;
      margin: 10px;
      &.panel-1 {
        width: calc(100% - 60px);
        p {
          &:nth-of-type(1) {
            font-size: 20px;
            margin-bottom: 10px;
          }
          &:nth-of-type(2) {
            font-size: 16px;
            color: @color-text-3;
          }
        }
      }
      &.panel-2,
      &.panel-3,
      &.panel-4 {
        width: calc(100%/3 - 60px);
        cursor: pointer;
        p {
          &:nth-of-type(2) {
            font-size: 40px;
            color: @color-primary;
          }
        }
      }
      &.panel-5 {
        width: calc(100% - 60px);
      }
    }
  }
  /deep/ .el-drawer {
    &.info {
      .el-drawer__body {
        background-color: @color-1;
        padding: @distance;
      }
    }
    .el-drawer__body {
      .el-table {
        display: flex;
        flex-wrap: wrap;
        background-color: initial;
        &::before {
          height: 0;
        }
        .item {
          background-color: @color-white;
          padding: @distance;
          text-align: center;
          width: calc(20% - 56px);
          transition: all @time;
          cursor: pointer;
          margin: 10px 0 10px 20px;
          &:nth-of-type(5n+1) {
            margin-left: 0;
          }
          &:hover {
            box-shadow: @box-shadow-1;
          }
          .el-image {
            width: 90px;
            height: 90px;
            border-radius: 50%;
            margin: 0 auto;
          }
          .number {
            font-size: 16px;
            font-weight: bold;
            margin: 10px 0;
            .text-overflow;
          }
          .el-tag {
            min-width: 45px;
          }
          .text {
            margin-top: 20px;
            font-weight: bold;
            color: @color-text-3;
            line-height: 24px;
          }
        }
      }
      .el-pagination {
        padding: @distance;
        background-color: @color-white;
        margin-top: 10px;
      }
      .empty {
        opacity: .5;
        display: flex;
        flex-direction: column;
        align-items: center;
        i {
          font-size: 24px;
          margin-bottom: 5px;
        }
      }
    }
  }
</style>